import { EmployeeSelector as EmployeeSelectorComponent } from 'modules/core/components/EntitySelectWrapper/Entities/Employees'
import type {
  EmployeeSelectorMultipleNoAccess,
  EmployeeSelectorMultipleUsingAccess,
  EmployeeSelectorSingleNoAccess,
  EmployeeSelectorSingleUsingAccess,
} from 'modules/core/components/EntitySelectWrapper/Entities/Employees/types'

import { EntitySelectorWrapper } from './EntitySelectorWrapper'

export const EmployeeSelector = (
  props:
    | EmployeeSelectorSingleUsingAccess
    | EmployeeSelectorSingleNoAccess
    | EmployeeSelectorMultipleNoAccess
    | EmployeeSelectorMultipleUsingAccess
) => {
  return !(props.usingAccessIds ?? false) ? (
    <EmployeeSelectorComponent {...props}>{props.children}</EmployeeSelectorComponent>
  ) : (
    <EntitySelectorWrapper {...props} />
  )
}
